export enum WORKED_DAYS_NUMBER {
  OUT_OF_CONTRACT = -2,
  NOT_VALIDATED = -1,
}

export interface TimeReportInfo {
  isMonthOverworked: boolean;
  isOutOfContract: boolean;
  isValidated: boolean;
  monthWorkedDaysNumber: number;
  monthWorkingDays: string[];
  yearMonth: string;
}

export interface WorkedDay {
  id?: number;
  date: string;
  fullDay: boolean;
}

export interface TimeReport {
  id: number;
  userGid: string;
  yearMonth: string;
  workedDays: WorkedDay[];
  creationDate: string;
  lastModificationDate: string;
  lastUserModificationDate: string;
  totalWorkedDays: number;
}
